
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export class StoreTableMix extends Vue {
    get columns(): ITableColumn[] {
        return [
            {
                title: '',
                dataIndex: '',
                scopedSlots: {
                    customRender: 'menu' 
                }
            },
            {
                title: i18nText("наименование"),
                dataIndex: 'name',
                key: 'name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'name'
                }
            },
            {
                title: i18nText("кол-во товаров"),
                dataIndex: 'product_count',
                key: 'product_count',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                }
            },
            {
                title: '',
                dataIndex: 'id',
                key: 'id',
                scopedSlots: {
                    customRender: 'action'
                }
            }
        ];
    }
}
